var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['base-page-heading', { 'pad-horizontal': _vm.padHorizontal }]},[(_vm.icon)?_c('img',{staticClass:"icon-base-page-heading",attrs:{"src":_vm.icon}}):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }